import moment from 'moment';
import {
  AppWindow,
  ApplicationType,
  WindowMetaData,
  WindowType,
} from '../types';
import { v4 as uuid } from 'uuid';
import { Size } from '../../core/types/ui/size';
import { IPosition2d } from '../../core/types/ui/position';
import { WindowSizes } from '../constants/windowSizes';

export const findWindowIndex = (windows: AppWindow[], windowId: string) =>
  windows.findIndex((window: AppWindow) => window.id === windowId);

export const findWindow = (windows: AppWindow[], windowId: string) =>
  windows.find((window: AppWindow) => window.id === windowId);

export const findLastActiveWindow = (windows: Array<AppWindow>) =>
  windows
    .slice()
    .reverse()
    .find((window: AppWindow) => !window.isMinimized);

export const removeWindow = (windows: AppWindow[], windowId: string) =>
  windows.filter((window: AppWindow) => window.id !== windowId);

export const getNewWindowDims = (maxDims: IPosition2d & Size) => {
  const HEIGHT_PER = 0.9; // 0.8
  const WIDTH_PER = 0.8; //0.6

  const height = Math.max(
    Math.floor(maxDims.height * HEIGHT_PER),
    WindowSizes.minHeight
  );
  const width = Math.max(
    Math.floor(maxDims.width * WIDTH_PER),
    WindowSizes.minWidth
  );
  const x = Math.floor((window.innerWidth - width) / 2);
  const y = Math.floor((window.innerHeight - height) / 2);
  return {
    y,
    x,
    height,
    width,
  };
};

export const createWindow = (
  maxDims: IPosition2d & Size,
  metaData?: WindowMetaData
): AppWindow => {
  const dims = getNewWindowDims(maxDims);
  return {
    id: uuid(),
    // topSection: {
    //   controlBar: {
    //     height: 30,
    //     isVisible: true,
    //   },
    // },
    // bottomSection: {
    //   statusBar: {
    //     height: 30,
    //     isVisible: true,
    //   },
    // },
    metaData: {
      appType: ApplicationType.Drive,
      ...metaData,
    },
    isMinimized: false,
    isMaximized: false,
    // windowType: WindowType.App,
    // sheetId: '',
    // appType: ApplicationType.Sheet,

    // top: 0,
    // left: 0,
    // width: 100,
    // height: 100,
    ...dims,
    // ...metaData,

    createdDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  };
};
